import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import {
  canadianProvinceCodeMap,
  usStateCodeMap,
} from "@/Helpers/fullStateOrProvinceName";

interface ShipmentStatesDropdownProps {
  stateOrProvinceCode: string | undefined;
  onStateOrProvinceCodeChange: (newValue: string | undefined) => void;
  label?: string | undefined;
}

function ShipmentFilterStateProvinceDropdown(
  props: ShipmentStatesDropdownProps,
) {
  const options = [
    {
      value: "any-state",
      label: "Any state / province",
    },
    ...Object.entries(canadianProvinceCodeMap).map(([key, value]) => ({
      value: key,
      label: value,
      group: "Canadian Provinces",
    })),
    ...Object.entries(usStateCodeMap).map(([key, value]) => ({
      value: key,
      label: value,
      group: "US States",
    })),
  ];

  const dropdown = (
    <Dropdown
      placeholder="Any state / province"
      value={props.stateOrProvinceCode}
      onChange={(v) => {
        if (v === "any-state") {
          props.onStateOrProvinceCodeChange(undefined);
        } else {
          props.onStateOrProvinceCodeChange(v);
        }
      }}
      options={options}
      width="full"
    />
  );

  return props.label !== undefined ? (
    <FormItem label={props.label} fillWidth>
      {dropdown}
    </FormItem>
  ) : (
    dropdown
  );
}
export default ShipmentFilterStateProvinceDropdown;
